module.exports = __webpack_public_path__ + "photos_empty_state-127cd46e8031d00d167db3da8a003e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos_empty_state.jpg
// module id = 1447
// module chunks = 1